module.exports = __webpack_public_path__ + "static/media/construction_worker.3a89486b.svg";